<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">
    // these are this sections defaults
    export const HeadingDefaults = {
        "name": "heading",
        "text": {
            "name": "text",
            "style": {},
            "innerText": "Heading",
        },
        "meta": {
            "order": {
                "text": 0
            }
        }
    }
    
</script>

<script>


</script>


    <h1 data-i-name="text"/>


<style> 



</style>